import { useTranslate } from '@/hooks'
import { MediaImageIcon } from '@/ui/icons/media-image'
import type { ReturnsCalculatedSummaryReturnedItem } from '@itsrever/rever-api'
import { useTranslation } from 'react-i18next'

interface ReturnedItemsProps {
  returnedItems: ReturnsCalculatedSummaryReturnedItem[]
}

export const ReturnedItems = ({ returnedItems }: ReturnedItemsProps) => {
  const { t } = useTranslation()
  const { translate } = useTranslate()

  return (
    <section className="w-full rounded-lg border border-neutral-300/50 bg-white p-6 shadow-sm">
      <header className="mb-4 flex items-center justify-between gap-4">
        <h2 className="text-sm font-medium text-neutral-900">
          {t('tracking_new.returned_items_title')}
        </h2>
        <span className="inline-block text-xs font-normal text-neutral-600">
          {t('confirmation.summary_items', {
            count: returnedItems?.length
          })}
        </span>
      </header>
      <ul className="flex flex-col gap-5">
        {returnedItems?.map((item, i) => (
          <li key={i} className="flex gap-3">
            <div className="relative h-20 w-[4.5rem] shrink-0 overflow-clip rounded-md">
              {item.image_url ? (
                <img
                  src={item.image_url}
                  alt={item.name}
                  height={80}
                  width={72}
                  className="size-full object-cover"
                />
              ) : (
                <div className="flex size-full min-h-0 items-center justify-center bg-neutral-50 text-neutral-500">
                  <MediaImageIcon width={18} height={18} />
                </div>
              )}
              {item.quantity && item.quantity > 1 ? (
                <span className="absolute bottom-1 right-1 rounded-sm bg-white/50 p-0.5 px-1 text-xs font-medium backdrop-blur-sm">
                  x {item.quantity}
                </span>
              ) : null}
            </div>
            <div className="flex flex-col gap-1 pb-1">
              <p className="line-clamp-2 text-sm font-normal">{item.name}</p>
              <p className="text-xs font-normal text-neutral-500">
                {item.variant_name}
              </p>
              {item.return_reason ? (
                <p
                  className="mt-auto line-clamp-1 w-fit rounded-sm bg-neutral-100 px-2 py-0.5 text-xs font-normal text-neutral-800"
                  dangerouslySetInnerHTML={{
                    __html: translate(`select_reason_${item.return_reason}`)
                  }}
                />
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
